import { jsonProperty, Serializable } from "ts-serializable";

class AgendaMes extends Serializable{
    @jsonProperty(String, null)
    data: string | null = null;

    @jsonProperty(String, null)
    mes: string | null = null;

    @jsonProperty(String, null)
    mesDescricao: string | null = null;

    @jsonProperty(String, null)
    unidadeAtendimentoId: string | null = null;

    @jsonProperty(Number)
    quantidadeHorariosAgendados: number = 0;

    @jsonProperty(Boolean)
    inativo: boolean = false;

    @jsonProperty(Boolean)
    ativavel: boolean = false;

    @jsonProperty([String], null)
    agendaIds: string[] | null = null;

}

export default AgendaMes;